import CarModelTable from "../component/car-models/CarModelTable";

export const ModelsCar = () => {
  return (
    <>
      <div>
        <CarModelTable />
      </div>
    </>
  );
};
